import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import Login from './pages/Login';
import ProtectedRoute from './pages/ProtectedRoute';
import Dashboard from './components/Dashboard';
import Products from './pages/Products';
import AddProduct from './pages/AddProduct';
import UpdateProduct from './pages/UpdateProduct';
import ViewProduct from './pages/ViewProduct';
import ContactUs from './pages/ContactUs';
import User from './pages/User';
import AddUser from './pages/AddUser';
import UpdateUser from './pages/UpdateUser';
import AdminLayout from './pages/AdminLayout';
import AddMostSaleProduct from './pages/AddMostSaleProduct';
import MostSaleProduct from './pages/MostSaleProduct';
import UpdateMostSaleProduct from './pages/UpdateMostSaleProduct';
import ViewMostSaleProduct from './pages/ViewMostSaleProduct';
import ViewContactUs from './pages/ViewContactUs';
import AddSliderImages from './pages/AddSliderImages';
import SliderImages from './pages/SliderImages';
import ViewSliderImages from './pages/ViewSliderImages';
import UpdateSliderImages from './pages/UpdateSliderImages';

const App = () => {
  return (
    <SnackbarProvider maxSnack={3}>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />

          {/* Protected Routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="products" element={<Products />} />
              <Route path="add-product" element={<AddProduct />} />
              <Route path="editProduct/:id" element={<UpdateProduct />} />
              <Route path="viewProduct/:id" element={<ViewProduct />} />
              <Route path="contactUs" element={<ContactUs />} />
              <Route path="viewContactUs/:id" element={<ViewContactUs />} />
              <Route path="user" element={<User />} />
              <Route path="addUser" element={<AddUser />} />
              <Route path="editUser/:id" element={<UpdateUser />} />
              <Route path="mostProduct" element={<MostSaleProduct />} />
              <Route path="add-mostProduct" element={<AddMostSaleProduct />} />
              <Route path="editMostProduct/:id" element={<UpdateMostSaleProduct />} />
              <Route path="viewMostProduct/:id" element={<ViewMostSaleProduct />} />
              <Route path="sliderImage" element={<SliderImages />} />
              <Route path="addSliderImage" element={<AddSliderImages />} />
              <Route path="viewSliderImage/:id" element={<ViewSliderImages />} />
              <Route path="editSliderImage/:id" element={<UpdateSliderImages />} />

            </Route>
          </Route>
        </Routes>
      </Router>
    </SnackbarProvider>
  );
};

export default App;
